const AWS = require('aws-sdk')
import settingsService from './settingsService'

// AWS configuration will be loaded from API
let awsConfig = null
let cloudfront = null
let cloudfrontParams = null

/**
 * Initialize AWS configuration from API
 * @returns {Promise} Promise that resolves when AWS config is loaded
 */
async function initializeAwsConfig() {
  if (awsConfig) {
    console.log('Using cached AWS config:', awsConfig)
    return awsConfig // Return cached config if already loaded
  }

  try {
    console.log('Loading AWS config from settings service...')
    awsConfig = await settingsService.getAwsConfig()
    console.log('AWS config loaded successfully:', awsConfig)
    
    // Initialize CloudFront with the loaded config
    cloudfront = new AWS.CloudFront({
      region: awsConfig.bucketRegion,
      accessKeyId: awsConfig.accessKeyId,
      secretAccessKey: awsConfig.secretAccessKey,
      Bucket: awsConfig.bucketName
    })

    // Initialize CloudFront invalidation parameters
    cloudfrontParams = {
      DistributionId: awsConfig.cloudfrontDistributionId,
      /* required */
      InvalidationBatch: {
        /* required */
        CallerReference: "'" + Math.floor(Date.now() / 1000) + "'",
        /* required */
        Paths: {
          /* required */
          Quantity: 1,
          /* required */
          Items: [
            '/*',
          ]
        }
      }
    }

    return awsConfig
  } catch (error) {
    console.error('Failed to initialize AWS configuration:', error)
    throw new Error('Unable to load AWS configuration from API')
  }
}

export default {
  async uploadToS3(file, banner, callback) {
    try {
      // Initialize AWS configuration
      const config = await initializeAwsConfig()
      
      let s3bucket = new AWS.S3({
        region: config.bucketRegion,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
        Bucket: config.bucketName
      })

      s3bucket.createBucket(function (data) {
        var params = {
          Bucket: config.bucketName,
          Key: 'app/top_banner/' + file.name,
          Body: file.data
        }

        s3bucket.upload(params, function (err, data) {
          if (err) {
            callback(err)
          } else {
            var paramss = {
              Bucket: config.bucketName,
              Key: 'app/v1.json',
            }
            s3bucket.getObject(paramss, function (err, existingdata) {
              var json = JSON.parse(existingdata.Body.toString('utf-8'))
              if (banner == 'US') {
                json.view_us.top_banner_image_url = data.Location
              } else {
                json.view.top_banner_image_url = data.Location
              }

              var file = JSON.stringify(json)
              paramss.Body = file
              s3bucket.putObject(paramss, function (err, datass) {
                if (!err) {
                  cloudfront.createInvalidation(cloudfrontParams, function (err, data) {
                    if (err) console.log(err, err.stack) // an error occurred
                    else callback(data) // successful response
                  })
                }
              })
            })
          }
        })
      })
    } catch (error) {
      console.error('Error in uploadToS3:', error)
      callback(error)
    }
  },

  async updateBannerLink(link, banner, callback) {
    try {
      // Initialize AWS configuration
      const config = await initializeAwsConfig()
      
      let s3bucket = new AWS.S3({
        region: config.bucketRegion,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
        Bucket: config.bucketName
      })

      var paramss = {
        Bucket: config.bucketName,
        Key: 'app/v1.json',
      }

      s3bucket.getObject(paramss, function (err, existingdata) {
        var json = JSON.parse(existingdata.Body.toString('utf-8'))
        if (banner == 'US') {
          json.view_us.top_banner_link_url = link
        } else {
          json.view.top_banner_link_url = link
        }
        var file = JSON.stringify(json)
        paramss.Body = file
        s3bucket.putObject(paramss, function (err, datass) {
          if (!err) {
            cloudfront.createInvalidation(cloudfrontParams, function (err, data) {
              if (err) console.log(err, err.stack) // an error occurred
              else callback(datass) // successful response
            })
          }
        })
      })
    } catch (error) {
      console.error('Error in updateBannerLink:', error)
      callback(error)
    }
  },

  async selectNoImage(arg, callback) {
    try {
      // Initialize AWS configuration
      const config = await initializeAwsConfig()
      
      let s3bucket = new AWS.S3({
        region: config.bucketRegion,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
        Bucket: config.bucketName
      })

      var paramss = {
        Bucket: config.bucketName,
        Key: 'app/v1.json',
      }

      s3bucket.getObject(paramss, function (err, existingdata) {
        var json = JSON.parse(existingdata.Body.toString('utf-8'))
        if (arg == 'US') {
          json.view_us.top_banner_image_url = ''
        } else {
          json.view.top_banner_image_url = ''
        }
        var file = JSON.stringify(json)
        paramss.Body = file
        s3bucket.putObject(paramss, function (err, datass) {
          if (!err) {
            cloudfront.createInvalidation(cloudfrontParams, function (err, data) {
              if (err) console.log(err, err.stack) // an error occurred
              else callback(datass) // successful response
            })
          }
        })
      })
    } catch (error) {
      console.error('Error in selectNoImage:', error)
      callback(error)
    }
  },

  async getUploadedBanner(callback) {
    try {
      // Initialize AWS configuration
      const config = await initializeAwsConfig()
      
      let s3bucket = new AWS.S3({
        region: config.bucketRegion,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
        Bucket: config.bucketName
      })

      var paramss = {
        Bucket: config.bucketName,
        Key: 'app/v1.json',
      }
      s3bucket.getObject(paramss, function (err, existingdata) {
        if (err) {
          callback(err)
        } else {
          var json = JSON.parse(existingdata.Body.toString('utf-8'))
          callback(json)
        }
      })
    } catch (error) {
      console.error('Error in getUploadedBanner:', error)
      callback(error)
    }
  },

  async uploadAndGetBannerLink(file, banner, callback) {
    try {
      console.log("uploadAndGetBannerLink called with:", file, banner)
      // Initialize AWS configuration
      const config = await initializeAwsConfig()
      console.log("AWS config loaded:", config)
      
      let s3bucket = new AWS.S3({
        region: config.bucketRegion,
        accessKeyId: config.accessKeyId,
        secretAccessKey: config.secretAccessKey,
        Bucket: config.bucketName
      })

      s3bucket.createBucket(function (data) {
        var params = {
          Bucket: config.bucketName,
          Key: 'app/top_banner/' + file.name,
          Body: file.data
        }

        s3bucket.upload(params, function (err, data) {
          if (err) {
            callback(err)
          } else {
            var paramss = {
              Bucket: config.bucketName,
              Key: 'app/v1.json',
            }
            s3bucket.getObject(paramss, function (err, existingdata) {
              var json = JSON.parse(existingdata.Body.toString('utf-8'))
              if (banner == 'US') {
                json.view_us.top_banner_image_url = data.Location
              } else {
                json.view.top_banner_image_url = data.Location
              }
              console.log("data-->>", data)
              console.log("err-->>", err)
              callback(data.Location)

              // var file = JSON.stringify(json)
              // paramss.Body = file
              // s3bucket.putObject(paramss, function (err, datass) {
              //   if (!err) {
              //     cloudfront.createInvalidation(cloudfrontParams, function (err, data) {
              //       if (err) console.log(err, err.stack) // an error occurred
              //       else callback(data) // successful response
              //     })

              //   }
              // })
            })
          }
        })
      })
    } catch (error) {
      console.error('Error in uploadAndGetBannerLink:', error)
      callback(error)
    }
  }
}


// WEBPACK FOOTER //
// ./src/services/s3Upload.js